<template>
    <div>
        <div class="page-wrapper">
            <div class="page-bg"></div>
            <div class="page-content">
                <TopBarDark
                    :title="lbl.static.privacy.title_topbar"
                    @clickBack="clickBack()">
                </TopBarDark>
                <div class="privacy-page">
                    <div class="wrapper-privacy">
                        <div class="text-detail" v-html="privacyContent"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//helper
import Account from "@/helper/AccountHelper.js";
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
//component
import TopBarDark from "@/components/Layout/TopBarPage/TopBarDark.vue"
//service
import BzbsPDPA from "@/core/PDPA/service/BzbsPDPA.js";

export default {
    name: 'Privacy',
    components: {
        TopBarDark
    },
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin],
    data: function() {
        return {
            profile: Account.getCacheProfile(),
            isLogin: false,

            privacyContent: '',
            privacyVersion: 0,
        };
    },
    created: function() {
        Account.loginStatus().then((status) => {
            this.isLogin = status;
        });
        this.initialPDPA();
    },
    methods: {
        clickBack: function () {
            this.$router.back();
        },
        initialPDPA: function () {
            return new Promise((resolve, reject) => {
                BzbsPDPA.apiGetPDPAVersion()
                .subscribe((data) => {
                    this.privacyVersion = data.privacy;
                    resolve(data);
                    BzbsPDPA.apiGetPDPAContent('privacy', this.privacyVersion, this.localeCode)
                    .subscribe((data) => {
                        this.privacyContent = data;
                        resolve(data);
                    }, (err) => {
                        this.errorApi(err);
                        reject(err);
                    });
                }, (err) => {
                    this.errorApi(err);
                    reject(err);
                })
            });
        },
    },
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
.page-wrapper {
    .page-bg {
        background-color: $white;
    }
}
.privacy-page {
    .wrapper-privacy {
        @include bg-curve();
        position: absolute;
        bottom: unset;
        padding: 20px 10px 10px;

        .text-detail {
            font-size: 1.1rem;
            line-height: 1.56;
            text-align: left;
            font-size: 18px;
            line-height: 1.56;
            margin: 9px 37px 20px 32px;
            color: $black;

            @include mini-mobile(){
                font-size: 0.9rem;
            }
        }
    }
}

</style>
